import { AppointmentTooltip } from "@devexpress/dx-react-scheduler-material-ui";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type HeaderProps = React.ComponentProps<typeof AppointmentTooltip.Header>;

export const CustomHeader: React.FC<HeaderProps> = ({
  onHide,
  commandButtonComponent: CommandButton,
}) => {
  const { t } = useTranslation(['global'])
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
      <Typography variant="h6">{t('event-details')}</Typography>
      {onHide && <CommandButton id="close" onExecute={onHide} />}
    </Box>
  );
};